<template>
  <div>
    <!--     <div class="vld-parent mycenter">
      <loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>   -->
    <DormList :dorms="dorms" v-if="dorms"/>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>

    <ContentLoader v-if="!dorms && !this.$helpers.mobileCheck"
    :height="900">
      <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
      <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />

      <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
      <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />
    </ContentLoader>
    <ContentLoader v-if="!popupDorms && this.$helpers.mobileCheck">
      <rect x="3" y="0" rx="3" ry="3" width="376" height="800" />
    </ContentLoader>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
// import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex'
import { ContentLoader } from 'vue-content-loader'
export default {
  name: 'UniversityMain',
  components: {
    DormList,
    FixedPopup,
    InfiniteLoading,
    // Loading,
    ContentLoader
  },
  metaInfo () {
    return {
      // http://api.yurtlarburada.com/site/universities/dorms/istanbul-teknik-universitesi
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.universityDetails ? this.universityDetails.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.universityDetails ? this.universityDetails.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.universityDetails ? this.universityDetails.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath }
      ]
    }
  },
  data () {
    return {
      fullPath: '',
      isLoading: false,
      fullPage: true,
      page: 2,
      dorms: null,
      pagination: null,
      popupDorms: null,
      errors: []
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/site/universities/dorms/${this.$route.params.slug}?page=${this.page}`)
        .then(response => {
          if (response.data.data.data) {
            this.page += 1
            // self.pagination = response.data.data
            // if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
            if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) && Object.keys(response.data.data.data).length !== 0) {
              Object.keys(response.data.data.data).forEach(item => {
                self.dorms.push(response.data.data.data[item])
              })
              $state.loaded()
            } else {
              $state.complete()
            }
            // self.dorms = response.data.data.data
            self.popupDorms = response.data.popups
          }
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    getDorms () {
      let self = this
      this.isLoading = true
      axios.get(`/site/universities/dorms/${this.$route.params.slug}?page=1`)
        .then(response => {
          this.isLoading = false
          // self.pagination = response.data.data
          /*  if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) && Object.keys(response.data.data.data).length !== 0 ) {
              self.dorms = response.data.data.data
              $state.loaded()
            } else {
              $state.complete()
            }     */
          self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['universityDetails'])
  },
  mounted () {
    this.getDorms()
  },
  created () {
    const myString = this.$route.fullPath
    var lastChar = myString[myString.length - 1]

    if (lastChar === '/') {
      this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }
  },
  watch: {
    $route () {
      // this.getDorms()
    }
  }
}
</script>

<style scoped>
.mycenter {
 display:table;
 margin:0 auto;
}
</style>
